"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createSearchUrl = require("../createSearchUrl");
var _createParametrizedUrl = _interopRequireDefault(require("../createParametrizedUrl"));
var getSearchUrl = function getSearchUrl(_ref) {
  var url = _ref.url,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? null : _ref$query,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 0 : _ref$currentPage,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
    _ref$pickedFilters = _ref.pickedFilters,
    pickedFilters = _ref$pickedFilters === void 0 ? {} : _ref$pickedFilters,
    categoryId = _ref.categoryId,
    lang = _ref.lang,
    _ref$productSearch = _ref.productSearch,
    productSearch = _ref$productSearch === void 0 ? true : _ref$productSearch;
  var params = Object.keys(pickedFilters).reduce(function (currentFilters, filterName) {
    if (filterName === "sort") {
      currentFilters.push({
        sort_field: pickedFilters[filterName].value.split("-")[0],
        direction: pickedFilters[filterName].value.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
      return currentFilters;
    }
    if (Array.isArray(pickedFilters[filterName])) {
      currentFilters.push({
        field: filterName === "cat" ? "category_id" : filterName,
        value: pickedFilters[filterName].map(function (el) {
          return el.id;
        }),
        condition_type: "in",
        connector: _createSearchUrl.CONNECTORS.AND
      });
    } else {
      Object.keys(pickedFilters[filterName]).forEach(function (key) {
        currentFilters.push({
          field: filterName,
          value: pickedFilters[filterName][key],
          condition_type: key.replace("max", "to").replace("min", "from"),
          connector: _createSearchUrl.CONNECTORS.AND
        });
      });
    }
    return currentFilters;
  }, []);
  if (!pickedFilters["cat"] && categoryId) {
    params.unshift({
      field: "category_id",
      condition_type: "eq",
      value: categoryId,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (query) {
    params.unshift({
      search_phrase: query,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (productSearch) {
    params.push(pageSize ? {
      pageSize: pageSize
    } : {}, currentPage ? {
      currentPage: currentPage
    } : {}, {
      field: "type_id",
      value: "simple",
      connector: _createSearchUrl.CONNECTORS.AND
    }, {
      field: "visibility",
      condition_type: "in",
      value: global.__appConfig__.visibilityValuesForProductsList,
      connector: _createSearchUrl.CONNECTORS.AND
    });
  }
  if (categoryId) {
    if (!("sort" in pickedFilters)) {
      params.push({
        sort_field: global.__appConfig__.defaultSort.split("-")[0],
        direction: global.__appConfig__.defaultSort.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
      params.push({
        sort_field: global.__appConfig__.defaultSortAdditionalParameter.split("-")[0],
        direction: global.__appConfig__.defaultSortAdditionalParameter.split("-")[1],
        connector: _createSearchUrl.CONNECTORS.AND
      });
    }
  }
  return global.__appConfig__.elasticEnabled ? "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.elasticEndpointUrl, {
    lang: lang.language,
    domain: lang.domain
  })).concat((0, _createSearchUrl.createSearchUrl)(url, params.filter(function (param) {
    return Object.keys(param).length > 0;
  }))) : "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.restRootEndpointUrl, {
    lang: lang
  })).concat((0, _createSearchUrl.createSearchUrl)(url, [{
    field: "type_id",
    value: "simple",
    connector: _createSearchUrl.CONNECTORS.AND
  }, {
    field: "name",
    value: "".concat(encodeURI(query)),
    condition_type: "like",
    connector: _createSearchUrl.CONNECTORS.AND
  }, {
    pageSize: pageSize
  }, {
    currentPage: currentPage
  }]));
};
var _default = getSearchUrl;
exports["default"] = _default;